import store from '@/store'
import { clearTokenRefresh } from './init'

export default () => {
  clearTokenRefresh()
  var keycloakAuth = store.getters.SECURITY_AUTH
  keycloakAuth.logout()
  store.dispatch('authLogout')
}
